import { QBTestQuestionEto } from '../lib/api/types';

/**
 * Generates a standardized question ID from various possible sources
 * This ensures consistency between save and load operations
 */
export const getStandardQuestionId = (question: QBTestQuestionEto | null | undefined): string | null => {
  if (!question) return null;
  
  // Priority order:
  // 1. questionId (primary identifier)
  // 2. questionOrder (if numeric identifiers exist)
  // 3. questionNumber (legacy field)
  
  if (question.questionId) {
    return question.questionId;
  }
  
  // Use numeric identifiers with consistent prefix
  if (question.questionOrder !== undefined && question.questionOrder !== null) {
    return `q_order_${question.questionOrder}`;
  }
  
  if (question.questionNumber !== undefined && question.questionNumber !== null) {
    return `q_num_${question.questionNumber}`;
  }
  
  // If no identifier is found, log error and return null
  console.error('❌ No valid question identifier found:', question);
  return null;
};

/**
 * Validates if a question ID is in the expected format
 */
export const isValidQuestionId = (questionId: string | null | undefined): boolean => {
  if (!questionId) return false;
  
  // Check if it's a UUID-like format or our standard prefixed format
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const prefixedPattern = /^q_(order|num)_\d+$/;
  const simpleIdPattern = /^[a-zA-Z0-9_-]+$/;
  
  return uuidPattern.test(questionId) || 
         prefixedPattern.test(questionId) || 
         simpleIdPattern.test(questionId);
};

/**
 * Debug helper to log question ID generation
 */
export const debugQuestionId = (question: any, context: string) => {
  const standardId = getStandardQuestionId(question);  
  return standardId;
};